/**
 * Confirm merging adjacent scope blocks that share job, group, work scope, and contiguous dates.
 */
import { ModalWrapper } from "../../../../components/ui";
import { Button } from "../../../../components/ui";

/**
 * Confirm merging adjacent scope blocks that share job, group, work scope, and contiguous dates.
 *
 * @param {Object} props
 * @param {boolean} props.open When true, the modal is visible.
 * @param {() => void} props.onConfirm User chose to merge adjacent blocks.
 * @param {() => void} props.onClose User declined merge or dismissed the modal.
 * @returns {JSX.Element}
 */
export default function ScheduleJoinScopeBlocksModal({
  open,
  onConfirm,
  onClose,
}) {
  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      closeButton={false}
      closeOnOutsideClick={false}
      maxWidth={420}
      overlayClassName="z-[10060]"
    >
      <div role="dialog" aria-modal="true" aria-labelledby="schedule-join-scope-title">
        <div className="border-b border-gray-200 px-4 py-3">
          <h2
            id="schedule-join-scope-title"
            className="text-base font-semibold text-gray-900"
          >
            Combine scope blocks?
          </h2>
        </div>
        <div className="px-4 py-4 text-sm text-gray-700">
          Scope blocks with the same job, group, work scope and contiguous dates detected. Would you like to combine these scope blocks into a single block?
        </div>
        <div className="px-4 py-3">
          <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-100 pt-4">
            <Button
              variant="custom"
              className="border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-100"
              onClick={onClose}
              text="No"
            />
            <Button
              variant="custom"
              className="bg-gray-900 px-3 py-1.5 text-sm font-medium text-white hover:bg-gray-800"
              onClick={onConfirm}
              text="Yes"
            />
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}
